import React from "react";
import { ArrowRight, Plus, User, RefreshCw } from "lucide-react";
import DealActivity from "@/model/interface/DealActivity";
import { memberName } from "@/util/member";

interface DealActivityFeedProps {
  activities: DealActivity[];
}

export function DealActivityFeed({ activities }: DealActivityFeedProps) {
  if (activities.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-4">
        No activity yet
      </p>
    );
  }

  const getIcon = (type: string) => {
    switch (type) {
      case "CREATED":
        return <Plus className="h-3.5 w-3.5" />;
      case "STAGE_CHANGED":
        return <ArrowRight className="h-3.5 w-3.5" />;
      case "ASSIGNED":
        return <User className="h-3.5 w-3.5" />;
      default:
        return <RefreshCw className="h-3.5 w-3.5" />;
    }
  };

  const formatTime = (date?: string) => {
    if (!date) return "";
    const d = new Date(date);
    const now = new Date();
    const diff = now.getTime() - d.getTime();
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return "just now";
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    return d.toLocaleDateString();
  };

  return (
    <div className="space-y-3">
      {activities.map((activity) => {
        const actorName = activity.membership ? memberName(activity.membership, "") : "System";

        return (
          <div key={activity.id} className="flex items-start gap-3 text-sm">
            <div className="mt-0.5 p-1 rounded-full bg-muted text-muted-foreground">
              {getIcon(activity.type)}
            </div>
            <div className="flex-1">
              <p>
                <span className="font-medium">{actorName}</span>{" "}
                <span className="text-muted-foreground">{activity.description}</span>
              </p>
              <p className="text-xs text-muted-foreground">{formatTime(activity.createdAt)}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
